import React from 'react';
import { Route } from 'react-router-dom';
import BlogPage from '../pages/Blog/BlogPage';
import BlogArticlePage from '../pages/Blog/BlogArticlePage';
import {
  isLocaleRouteEnabled,
  isLocaleRoutesDeEnabled,
  isLocaleRoutesEnEnabled,
  isLocaleRoutesEsEnabled,
  isLocaleRoutesItEnabled,
  type MarketingLocale,
} from '../config/localeRoutes';

const LOCALIZED_BLOG_LOCALES: MarketingLocale[] = ['es', 'en', 'de', 'it'];

function localeEnabled(locale: MarketingLocale): boolean {
  if (locale === 'es') return isLocaleRoutesEsEnabled();
  if (locale === 'en') return isLocaleRoutesEnEnabled();
  if (locale === 'de') return isLocaleRoutesDeEnabled();
  if (locale === 'it') return isLocaleRoutesItEnabled();
  return isLocaleRouteEnabled(locale);
}

/** Routes blog /{locale}/blog pour ES, EN, DE, IT (FR reste sur /blog). */
export function localizedBlogRoutes(): React.ReactNode {
  return (
    <>
      {LOCALIZED_BLOG_LOCALES.filter(localeEnabled).map((locale) => {
        const prefix = `/${locale}/blog`;
        return (
          <React.Fragment key={locale}>
            <Route path={prefix} element={<BlogPage locale={locale} />} />
            <Route path={`${prefix}/:slug`} element={<BlogArticlePage locale={locale} />} />
            <Route
              path={`${prefix}/category/:categorySlug`}
              element={<BlogPage locale={locale} />}
            />
          </React.Fragment>
        );
      })}
    </>
  );
}
